import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import DinamicTable from "../table";
import CheckBox from "../custom-components/checkbox";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { useTranslation } from "react-i18next";

const TableAdmissions = (props) => {
  const { data, page, sizePerPage, totalSize, onTableChange, addmissionType } =
    props;

  const [selectElements, setSelectElements] = useState({});
  const [checkAll, setCheckAll] = useState({});

  const headers = useMemo(
    () => setHeaders(props.headers, props.page),
    [props.headers, props.page, checkAll, selectElements]
  );

  function setHeaders(headers, page) {
    var resultHeader = [...headers];

    resultHeader.unshift({
      grow: 0,
      selector: "checkbox",
      // name: 'Check',
      name: (
        <CheckBox
          id={`checkbox-${page}`}
          label=""
          name="checkbox"
          onChange={(e) => checkAllItems(e)}
          checked={checkAll[`checkbox-${page}`] !== undefined ? true : false}
        />
      ),
      center: true,
      bodyStyle: {
        flexGrow: 0,
      },
      cellFormatter: (row) => checkBoxItems(row),
    });

    return resultHeader;
  }

  const checkBoxItems = (item) => {
    var disabled =
      item.recordComplete !== undefined
        ? item.recordComplete === true
          ? false
          : item.recordTmps === null && false
        : false;

    return (
      <CheckBox
        key={`${addmissionType}-${item.id}-${item.item?.provider?.currencyAux}`}
        id={`${addmissionType}-${item.id}-${item.item?.provider?.currencyAux}`}
        label={``}
        name={`${addmissionType}-${item.id}-${item.item?.provider?.currencyAux}`}
        disabled={disabled}
        onChange={changeSelected}
        checked={
          selectElements[
            `${addmissionType}-${item.id}-${item.item?.provider?.currencyAux}`
          ] !== undefined
        }
      />
    );
  };

  const checkAllItems = (e) => {
    const tmpElements = { ...selectElements };
    const tmpCheckAll = { ...checkAll };

    props.data.map((item) => {
      const id = `${addmissionType}-${item.id}-${item.item?.provider?.currencyAux}`;
      if (!e.target.checked && tmpElements[id] !== undefined) {
        delete tmpElements[id];
      } else if (e.target.checked) {
        tmpElements[id] = e.target.checked;
      }
    });

    setSelectElements(tmpElements);

    if (!e.target.checked && tmpCheckAll[e.target.id]) {
      delete tmpCheckAll[e.target.id];
    } else if (e.target.checked) {
      tmpCheckAll[e.target.id] = e.target.checked;
    }

    setCheckAll(tmpCheckAll);
  };

  const setTableData = () => {
    var resultData = [];

    if (data.length > 0) {
      data.map((item) => {
        resultData.push({
          ...item,
        });
      });
    }

    return resultData;
  };

  const changeSelected = (event) => {
    const tmpElements = { ...selectElements };

    if (!event.target.checked && tmpElements[event.target.id] !== undefined) {
      delete tmpElements[event.target.id];
    } else if (event.target.checked) {
      tmpElements[event.target.id] = event.target.checked;
    }

    setSelectElements(tmpElements);
  };

  const handleTableChange = ({ page, sizePerPage, customFilters = [] }) => {
    // Modal
    return onTableChange({ page, sizePerPage, customFilters });
  };

  const buttons = useTranslation().t("general.buttons", {
    returnObjects: true,
  });

  const getActions = () => {
    const usersLength = Object.keys(selectElements).length;

    return (
      <div className="form-actions clearfix">
        <SecondaryButton
          id={`reject-btn`}
          className="cancell"
          onClick={() => props.submitAdmissions(false, selectElements)}
          disabled={usersLength <= 0}
        >
          {buttons.rejected}
        </SecondaryButton>
        <SecondaryButton
          id={`aprove-btn`}
          className="accept"
          onClick={() => props.submitAdmissions(true, selectElements)}
          disabled={usersLength <= 0}
        >
          {buttons.approve}
        </SecondaryButton>
      </div>
    );
  };

  return (
    <DinamicTable
      page={page}
      data={setTableData()}
      headers={headers}
      actions={getActions()}
      totalSize={totalSize}
      sizePerPage={sizePerPage}
      onTableChange={handleTableChange}
    />
  );
};

TableAdmissions.propTypes = {
  headers: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  totalSize: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  addmissionType: PropTypes.string.isRequired,
};

export default TableAdmissions;
